export default __webpack_public_path__ + "assets/a06ef9c14a5663cfb34a12faace29381.jpeg";